module.exports = __webpack_public_path__ + "img/15.dd378619.jpg";